export function getProfileLevelColorUse(partnerType, tier) {
  if (tier === 'NONE') {
    if (partnerType === 'PARTNER' || partnerType === 'RESELLER') {
      return 'koala';
    } else if (partnerType === 'PROVIDER') {
      return 'koala';
    } else {
      return undefined;
    }
  } else {
    switch (tier) {
      case 'DIAMOND':
        return 'pantera';
      case 'ELITE':
        return 'lorax';
      case 'GOLD':
      case 'PLATINUM':
      default:
        return 'koala';
    }
  }
}